<div class="user">
  <img *ngIf="contratista?.logo"
    routerLinkActive="activo"
    [routerLink]="['perfil']"
    src={{contratista.logo}}
    alt=""
  />
  <img *ngIf="!contratista?.logo"
    routerLinkActive="activo"
    [routerLink]="['perfil']"
    src="./../../../../../assets/noimage.png"
    alt=""
  />
  <div class="datos">

    <div>
      <p class="nombre">
      <span class="nombre__title">Nombre Comercial:</span><br>{{contratista?.nombreComercial}}<br><br>
      <span class="nombre__title">Usuario:</span><br>{{userLogged.username.split('@')[0]}}<br>
      @{{userLogged.username.split('@')[1]}}
      </p>
      
    </div>
  </div>
</div>
